var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartGardenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MeinGarten",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.484,
    height: 49.999,
    viewBox: "0 0 45.484 49.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5d75d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2710",
    "data-name": "Gruppe 2710",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2660",
    "data-name": "Pfad 2660",
    className: "cls-1",
    d: "M24.992,56.631A22.743,22.743,0,0,1,21.61,11.4l.238,1.587a21.137,21.137,0,1,0,24.281,20.9,21.331,21.331,0,0,0-.589-4.976l1.561-.376A22.765,22.765,0,0,1,24.992,56.631",
    transform: "translate(-2.25 -6.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2661",
    "data-name": "Pfad 2661",
    className: "cls-1",
    d: "M44.341,24.56a13.352,13.352,0,0,0-6.755,3.367,11.588,11.588,0,0,0-2.221,3.217V24.036a3.115,3.115,0,0,1,1.381.735C38,25.942,39,25.5,38.978,23.786a3.2,3.2,0,0,1,3.07-3.218c1.712-.058,2.109-1.082.882-2.276a3.2,3.2,0,0,1-.1-4.448c1.171-1.251.727-2.255-.986-2.232a3.2,3.2,0,0,1-3.218-3.07c-.058-1.712-1.082-2.109-2.276-.882a3.2,3.2,0,0,1-4.448.1c-1.251-1.17-2.255-.727-2.232.987a3.2,3.2,0,0,1-3.072,3.218c-1.712.058-2.108,1.082-.881,2.276a3.2,3.2,0,0,1,.1,4.448c-1.17,1.251-.727,2.255.987,2.232a3.2,3.2,0,0,1,3.218,3.07c.058,1.712,1.081,2.109,2.276.882a3.139,3.139,0,0,1,1.556-.867V38.4a14.092,14.092,0,0,0-3-4.654,15.027,15.027,0,0,0-6.99-3.733A15.027,15.027,0,0,0,27.6,37a14.858,14.858,0,0,0,6.252,3.548v7.425A16.985,16.985,0,0,1,7.967,36.414c2.206,0,2.9-.01,3.15-.013a.825.825,0,0,0,.144-.006.755.755,0,0,0,.651-.748V27.628a.761.761,0,0,0-.071-.32l4.889-2.875,4.619,2.84a.758.758,0,0,0-.088.354v7.982h1.511V28.383h.6a.755.755,0,0,0,.395-1.4l-6.629-4.076a.753.753,0,0,0-.778-.009L9.423,26.976a.756.756,0,0,0,.383,1.407H10.4V34.9c-.566,0-1.56.006-3.3.006a.756.756,0,0,0-.751.84A18.5,18.5,0,0,0,35.032,49.012a.755.755,0,0,0,.333-.627V34.424a12.868,12.868,0,0,0,5.609-3.109,13.342,13.342,0,0,0,3.367-6.755M31.754,17.4a2.807,2.807,0,1,1,3.7,1.433,2.807,2.807,0,0,1-3.7-1.433",
    transform: "translate(-1.962 -6.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2446",
    "data-name": "Rechteck 2446",
    className: "cls-1",
    width: 2.948,
    height: 6.347,
    transform: "translate(13.195 22.199)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartGardenLogo);
export default __webpack_public_path__ + "static/media/smart-garden-logo.765c4dd9b403266ad65aea4d6f6a129e.svg";
export { ForwardRef as ReactComponent };